import WebFont from 'webfontloader';
import PageUtils from '../modules/pageutils';
import Hamburger from '../modules/hamburger'; 
import initializeGlider from '../modules/initialize-glider';
import Storelocator from '../modules/storelocator';
import FrontPage from '../modules/frontPage';
import Shop from '../modules/shop';
import popupMemberClose from "../modules/popupMemberClose";
import minHeight from '../modules/minHeight';
import team from '../modules/team';
import Rellax from 'rellax';
import ScrollOut from "scroll-out";
import Splitting from "splitting";
import Careertown from "../modules/careerTown";
import selectInCheckbox from "../modules/selectInCheckbox";
import selectInShippingCheckbox from "../modules/selectInShippingCheckbox";
import attributeCertification from "../modules/attributeCertification";
import ricettariMenu from "../modules/ricettariMenu";
import noProductsInOrder from "../modules/noProductsInOrder";
import createCookieReferrer from "../modules/createCookieReferrer";


export default {
  init() {
    // JavaScript to be fired on all pages
    WebFont.load({
        google: {
            families: ['Nunito:400,500,600,700,800'],
        },
        timeout: 4000,
    });
  },
  finalize() {
    // Set Utilities
    Storelocator();
    PageUtils();
    initializeGlider();
    Shop();
    minHeight();
    FrontPage();
    team();
    Careertown();
    popupMemberClose();
    selectInCheckbox();
    attributeCertification();
    ricettariMenu();
    noProductsInOrder();
    selectInShippingCheckbox();
    createCookieReferrer();

    // Hamburger
    let allHtml = document.querySelector('html'); 
    Hamburger.register('body',{
        onOpen: () => {
          allHtml.style.overflow = 'hidden';
        },
        onClose: () => {
          allHtml.style.overflow = 'auto';
        },
    });

    // Lettura viewport
    let vw = document.body.clientWidth * 0.01;
    let vh = window.screen.availHeight * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);


    const is_touch_enabled = () => { 
      return ( 'ontouchstart' in window ) ||  
            ( navigator.maxTouchPoints > 0 ) ||  
            ( navigator.msMaxTouchPoints > 0 ); 
    }

    if (!is_touch_enabled()) {
      document.body.classList.toggle('is-not-touchable');
    }

    // Chiusura Btn banner member onclick
    let closeBannerBtns = document.querySelectorAll('.js-close-banner');
    if(closeBannerBtns){
      closeBannerBtns.forEach(closeBannerBtn => {
      closeBannerBtn.addEventListener('click', () => {
        closeBannerBtn.parentNode.classList.add('closed');
        })
      });
    }

    let isBlog = document.body.classList.contains('blog');
    if(isBlog){ 
      document.body.classList.add('is-blog');
    }

    // WooCommerce quantity-input buttons
    document.querySelectorAll('.btn-plus').forEach(element => element.addEventListener('click', function(e) {
      e.preventDefault();
      const input = e.target.closest('.quantity').querySelector('input[type="number"]');
      input.value = Number(input.value) + 1;
      document.querySelector('.woocommerce-cart-form').querySelector('button[name="update_cart"]').disabled = false;
      document.querySelector('.woocommerce-cart-form').querySelector('button[name="update_cart"]').setAttribute('aria-disabled', false);

      if(e.target.closest('.quantity')){
        const updateBtn = e.target.closest('.quantity').closest('.product-quantity').nextElementSibling.querySelector('.updateCartBtn');
        updateBtn.classList.add('is-active');
        updateBtn.disabled = false;
      } 
    }));
    
    document.querySelectorAll('.btn-minus').forEach(element => element.addEventListener('click', function(e) {
      e.preventDefault();
      const input = e.target.closest('.quantity').querySelector('input[type="number"]');
      if (input.value>0) {
        input.value = Number(input.value) - 1;
      }
      document.querySelector('.woocommerce-cart-form').querySelector('button[name="update_cart"]').disabled = false;
      document.querySelector('.woocommerce-cart-form').querySelector('button[name="update_cart"]').setAttribute('aria-disabled', false);

      if(e.target.closest('.quantity')){
        const updateBtn = e.target.closest('.quantity').closest('.product-quantity').nextElementSibling.querySelector('.updateCartBtn');
        updateBtn.classList.add('is-active');
        updateBtn.disabled = false;
      }
    }));

    //Popup Member
    let popupMember = document.querySelector('.js-popupMember');
    if(popupMember) {
      popupMember.classList.add('is-active');
      let mainClass = document.querySelector('.main');
      mainClass.style.filter = 'blur(5px)';
      document.querySelectorAll('.Banner--Member').forEach(element => element.style.display='none');
    }

    //Parallax Blocco Immagine Testo
    const rellax = document.querySelector('.rellax'); 
    if(rellax){
      new Rellax('.rellax-down', {
        speed: -1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false,
      });
    }

    const appearTitle = document.querySelector('.Animations--AppearTitle');
    if(appearTitle){
      ScrollOut({ 
        targets:'.Animations--AppearTitle',  
        threshold: 0.8,
        onShown(appearTitle) {
          appearTitle.classList.add('startAnimation'); 
        }
      });

    }

    const splittingText = document.querySelector('.Animations--SplittingText');
    if(splittingText){
      Splitting({ 
        target: ".Animations--SplittingText", 
        by: "chars", 
        key: null
      });
    }

    //Woocomerce

    // const editAccountFormInput = document.querySelectorAll('.woocommerce-EditAccountForm .woocommerce-Input');
    
    // if(editAccountFormInput){
    //   editAccountFormInput.forEach(input => {
    //     if(input.value.length == 0){
    //       input.parentElement.style.display = "none";
    //     }
    //   });
    // }
     
    const checkoutForm = document.querySelector('.woocommerce-checkout .woocommerce-checkout .woocommerce-billing-fields__field-wrapper');
    
    if(checkoutForm){ 
      const inputForm = document.querySelectorAll('.form-row input');
      if(inputForm){
        inputForm.forEach(el => { 
          if(el.value.length == 0){
            el.parentElement.parentElement.style.display = "none";
          }
        }); 
      }


      const selectForm = document.querySelectorAll('.select2-selection__rendered');
      const contrySelectForm = document.querySelector('select.country_select');
      
      var options = contrySelectForm.options;
        for (let i = 0; i < options.length; i++) { 
          options[i].value === 'default';
          if(options[i].value === 'default'){
            let rightValue = options[i].text;

            selectForm.forEach(sel => {
              if(sel.title == rightValue){
                contrySelectForm.parentElement.parentElement.style.display = 'none';
              }
            });
          }
        }         
    }

    //Adding woocomerce theming
    const woocommerceBlock = document.querySelector('.woocommerce');
    if(woocommerceBlock){
      woocommerceBlock.classList.add('Theme');
      woocommerceBlock.classList.add('Theme--Light');
    }

    const addressInfosUser = document.querySelector('.woocommerce-EditAccountForm');
    if(addressInfosUser){ 
      if (document.documentElement.lang === "it-IT") {
        addressInfosUser.innerHTML += '<h3 class="TypoSize-16 woocommerce-EditAccountForm--Disclaimer"><a href="/contatti/">Per modificare i propri dati contattare l\'amministratore del sito</a></h3>';
      } else if (document.documentElement.lang === "en-US") {
        addressInfosUser.innerHTML += '<h3 class="TypoSize-16 woocommerce-EditAccountForm--Disclaimer"><a href="/en/contacts/">To modify your data, contact the site administrator.</a></h3>';
      }
    }

    const woocommerceInputWrapper = document.querySelectorAll('.woocommerce-input-wrapper');
    const woocomerceInputText = document.querySelectorAll('input');
    const woocomerceSelect = document.querySelectorAll('select');
    const thmafSelect = document.querySelector('#thmaf_billing_alt');
    const orderComment = document.querySelector('#order_comments');

    if(woocommerceInputWrapper){
      woocommerceInputWrapper.forEach( input => {
        input.style.pointerEvents = "none";
        input.readOnly = true;

        woocomerceInputText.forEach(inputText => { 
          inputText.readOnly = true;  
        });
       
        woocomerceSelect.forEach(select => { 
          select.style.pointerEvents = "none";
        });

      });
    }

    if(orderComment){
      orderComment.parentNode.readOnly = false;
      orderComment.parentNode.style.pointerEvents = "all";
    }

    if(thmafSelect){
      thmafSelect.parentNode.style.pointerEvents = "all";
      thmafSelect.style.pointerEvents = "all";
      thmafSelect.readOnly = false;
    }

    // Searchbar
    document.querySelectorAll('.searchbar input[type|="search"]').forEach(element => element.addEventListener('focusin', function(e) {
      e.target.closest('.searchbar').classList.add('searchbar--focused');
    }));
    document.querySelectorAll('.searchbar input[type|="search"]').forEach(element => element.addEventListener('focusout', function(e) {
      e.target.closest('.searchbar').classList.remove('searchbar--focused');
    }));
    document.querySelectorAll('.SearchPage input[type|="search"]').forEach(element => {element.addEventListener('keydown', function() {
        this.style.width = String(this.value.length * 0.55) + "em";
      });
      element.style.width = String(element.value.length * 0.55) + "em";
    });

    // Home Open Stor Parallax
    document.querySelectorAll('.rellax-bg').forEach(element => {
      rellaxresize(element);
      window.addEventListener('resize', function () {
        rellaxresize(element);
      });
    });

  }, //fine finalized
};

export function rellaxresize(element) {
  var mfactor = 1 + element.getAttribute('data-rellax-speed')/6;
  var natwidth = element.naturalWidth;
  var natheight = element.naturalHeight;
  var containerwidth = element.parentElement.offsetWidth;
  var containerheight = element.parentElement.offsetHeight;
  var aspect = natheight/natwidth;

  if (containerwidth * aspect > containerheight) {
    var newwidth = containerwidth * mfactor;
    var newheight = newwidth * aspect;

    element.parentElement.style.height = String(containerwidth * aspect) + "px";
    element.parentElement.style.maxHeight = "";
    element.style.height = String(newheight) + "px";
    element.style.width = String(newwidth) + "px";
    element.style.marginTop = String(containerwidth * aspect * (1 - mfactor)/2) + "px";
    element.style.marginLeft = String(newwidth * (1 - mfactor)/2) + "px";
  } else {
    var newheight = containerheight * mfactor;
    var newwidth = newheight / aspect;

    element.parentElement.style.height = String(containerheight) + "px";
    element.style.height = String(newheight) + "px";
    element.style.width = String(newwidth) + "px";
    element.style.marginTop = String(containerheight * (1 - mfactor)/2) + "px";
    element.style.marginLeft = String(newwidth * (1 - mfactor)/2) + "px";
  }
};